import * as requestFromServer from './organizationCrud';
import { organizationSlice, callTypes } from './organizationSlice';
import { actions as auth } from '../../../Auth/_redux/authRedux'
import { toastOption } from '../../../../../_metronic/_helpers/ToastHelpers'
import { toast } from 'react-toastify'

const { actions } = organizationSlice;

export const fetchOrganizations = (queryParams) => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.list }));
    return requestFromServer.findOrganizations(queryParams)
        .then(response => {
            const { data: { total_items, items } } = response.data;
            dispatch(actions.organizationsFetched({ total_items, items }));
        }).catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({ error, callType: callTypes.list }));
        });
};

export const fetchOrganization = () => dispatch => {
    // if (!id) {
    //     return dispatch(actions.organizationFetched({ organizationForEdit: undefined }));
    // }

    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer.getOrganizationById()
        .then(response => {
            let organization = response.data; // alias data -> organization
            dispatch(actions.organizationFetched({ organizationForEdit: organization }));
            return organization;
        }).catch(error => {
            console.log(error);
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};

export const fetchChilds = (id) => dispatch => {
    if (!id) {
        return dispatch(actions.childsFetched({ listChild: undefined }));
    }

    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer.getChilds(id)
        .then(response => {
            dispatch(actions.childsFetched({ childsFetched: response.data.data }));
        }).catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};

export const fetchParents = (id) => dispatch => {
    if (!id) {
        return dispatch(actions.parentsFetched({ listParent: undefined }));
    }

    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer.getParents(id)
        .then(response => {
            dispatch(actions.parentsFetched({ parentsFetched: response.data.data }));
        }).catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};

export const fetchDonationHistory = (queryParams) => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.list }));
    return requestFromServer.getDonationList(queryParams)
        .then(response => {
            const { data: { total_items, items } } = response.data;
            dispatch(actions.donationHistorysFetched({ total_items, items }));
        }).catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};



export const createOrganization = (organizationForCreation) => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer.createOrganization(organizationForCreation)
        .then(response => {
            dispatch(actions.organizationsReload);
            return response.data;
        })
        .catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({ error, callType: callTypes.list }));
            return error
        });
};

export const updateOrganization = (organization) => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer.updateOrganization(organization)
        .then(response => {
            toast.success(response.data.message, toastOption);
            dispatch(actions.organizationsReload);
            return response.data;
        })
        .catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({ error, callType: callTypes.list }));
        });
};

export const changePasswordOrganization = (payload) => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer.changePasswordOrganization(payload)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({ error, callType: callTypes.list }));
            return error
        });
};

export const migrateDonation = (payload) => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer.migrateDonation(payload)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({ error, callType: callTypes.list }));
            return error
        });
};

export const updateEmailConfiguration = payload => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateEmailConfiguration(payload)
    .then(response => {
      return response.data;
    })
    .catch(error => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
      return error;
    });
};

export const orgTestEmailConfiguration = payload => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .orgTestEmailConfiguration(payload)
    .then(response => {
        console.log(`response`, response);
      return response.data;
    })
    .catch(error => {
        console.log(`error`, error.response);
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      dispatch(actions.catchError({ error, callType: callTypes.list }));
      return error.response.data;
    });
};

